import { createSlice, PayloadAction, createAsyncThunk } from "@reduxjs/toolkit";
import { Device } from "../Common/Types/types";
import { RootState } from "../Core/Store";
import { DeviceApi } from "./api";
import axios from "axios";
import { baseUrl } from "../Common/Constants";
import { useAppDispatch } from "../Core/store.hooks";
import { Params } from "react-router";

const testDevices: Device[] = [
  {
    mainMachineSerialNo: "test",
    deviceName: "test",
    customerName: "test",
    customerID:"test",
    country: "test",
        customerAssemblyDeviceID: "175",
        deviceWithSerial: "test 1 (test)",
        versionNumber: "test 1",
        deviceSize: "test 1",
        deviceNameVersion:"test"
  },
];

interface deviceSliceState {
  devices: Device[];
  loadingState?: string;
  errorMessage?: string;
}
const initialDevices: Device[] = [];

const initialState: deviceSliceState = {
  devices: initialDevices,
  loadingState: undefined,
  errorMessage: undefined,
};

let url = baseUrl + "device";

export const fetchDevices = createAsyncThunk<Device[]>(
  "devices/fetchDevices",
  async () => {
    const response = await DeviceApi.getDevices();
    return response;
  }
);

const deviceSlice = createSlice({
  name: "devices",
  initialState,
  reducers: {
   
  },
  extraReducers: (builder) => {
    builder.addCase(fetchDevices.fulfilled, (state, action) => {
      return {
        ...state,
        loadingState: "fulfilled",
        errorMessage: undefined,
        devices: [...state.devices, ...action.payload],
      };
    });
    builder.addCase(fetchDevices.rejected, (state, action) => {
      return {
        ...state,
        loadingState: "rejected",
        errorMessage: "error",
      };
    });
    builder.addCase(fetchDevices.pending, (state, action) => {
      return {
        ...state,
        loadingState: "pending",
        errorMessage: undefined,
      };
    });
  },
});

export const getDevicesSelector = (state: RootState) => state.devices.devices;

export const loadingDevicesSelector = (state: RootState) => state.devices.loadingState;
export default deviceSlice.reducer;
